import { UapLoadStatus } from '@ad-engine/communication';
import { props } from 'ts-action';
import { Dictionary } from '@ad-engine/core';

export const AD_ENGINE_UAP_DOM_CHANGED = {
	name: 'UAP DOM changed',
	payload: props<{ element: string; size: number }>(),
} as const;
export const AD_ENGINE_UAP_LOAD_STATUS = {
	name: 'UAP Load status',
	payload: props<UapLoadStatus>(),
} as const;
export const AD_ENGINE_UAP_NTC_LOADED = {
	name: 'UAP NTC loaded',
} as const;
export const AD_ENGINE_UAP_CUSTOM_LOADER_CALLED = {
	name: 'Custom Loader called',
	payload: props<Dictionary>(),
} as const;
export const AD_ENGINE_STICKY_TLB_LEFT = {
	name: 'Sticky-tlb left',
} as const;
